
const TextField = {
    styleOverrides: {
        // placeholder to override the generic styles
        root: ({ ownerState, theme }) => {
            return {
            }
        },
        
    }
}

export default TextField